import { snakeStore, META, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { NumberService } from '@phone-number/services/NumberService';

export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'purchased_at',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: ({ commit }, params) => {
        return NumberService.getList(params).then((response) => {
          commit(META, response.meta);
          return response;
        });
      }
    }
  },
  true
);
